import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";
import ProductCard from "./ProductCard";
import SeoMeta from "@/components/SeoMeta";
import { useStoreBase } from "@/lib/store";
import { storefrontCardVariant } from "@/lib/storefrontTheme";

export default function StorefrontCategory({ config }) {
  const { catSlug } = useParams();
  const { slug, base, country } = useStoreBase();
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState(null);
  const [children, setChildren] = useState([]);

  useEffect(() => {
    api.get(`/store/${slug}/products?category=${catSlug}${country ? `&country=${country}` : ""}`).then(({ data }) => setProducts(data));
    api.get(`/store/${slug}/categories`).then(({ data }) => {
      const all = data || [];
      const current = all.find((c) => c.slug === catSlug);
      setCat(current);
      setChildren(current ? all.filter((c) => c.parent_id === current.id) : []);
    });
  }, [slug, catSlug, country]);

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      <SeoMeta endpoint={`/seo/${slug}/category/${catSlug}/meta`} fallback={{ title: cat?.name || catSlug }} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-stone-900">{cat?.name || catSlug}</h1>
      <p className="text-stone-500 text-sm mt-1">{products.length} products</p>
      {children.length > 0 && (
        <div className="mt-6 flex gap-3 overflow-x-auto no-scrollbar pb-1">
          {children.map((c) => (
            <Link key={c.id} to={`${base}/category/${c.slug}`} className="shrink-0 px-4 py-2 rounded-full border border-stone-200 bg-white text-sm font-medium text-stone-700 hover:border-stone-400" data-testid={`subcat-${c.slug}`}>
              {c.image_url ? <img src={mediaUrl(c.image_url)} alt="" className="inline-block w-5 h-5 rounded-full object-cover mr-2 align-middle" /> : null}
              {c.name}
            </Link>
          ))}
        </div>
      )}
      <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {products.map((p) => (<ProductCard key={p.id} p={p} slug={slug} variant={storefrontCardVariant(config)} />))}
      </div>
    </div>
  );
}
